import { Route } from '@sentry/vue/types/router';
import { RouteConfig } from 'vue-router';

import { EMBEDDED_PREFIX } from './router.const';
import { propsValidator } from '@/utils/helpers';
import EmbeddedAppLayout from '@/views/AppLayout/EmbeddedAppLayout.vue';
import EmbeddedCreationWizard from '@/views/EmbeddedPages/EmbeddedCreationWizard.vue';
import EmbeddedEditInstalledWorkflowConfiguration from '@/views/EmbeddedPages/EmbeddedEditInstalledWorkflowConfiguration.vue';
import ShareWorkflow from '@/views/ShareWorkflow.vue';
import SettingsOrganization from '@/views/settings/SettingsOrganization.vue';

const embeddedPropsValidator = (route: Route, component: unknown) =>
	propsValidator({ ...route, params: { ...(route.params || {}), embeddedMode: true } }, component);

export const embeddedAppRoute: RouteConfig = {
	path: '/e/:slug',
	name: `${EMBEDDED_PREFIX}Home`,
	component: EmbeddedAppLayout,
	children: [
		{
			path: 'settings',
			name: `${EMBEDDED_PREFIX}SettingsOrganization`,
			component: SettingsOrganization,
			meta: {
				icon: 'settings',
				title: 'Workspace Settings',
			},
		},
		{
			path: 'share-workflow/:workflowId',
			name: `${EMBEDDED_PREFIX}ShareWorkflow`,
			component: ShareWorkflow,
			props: (route) => ({ workflowId: parseInt(route.params.workflowId) }),
		},
		{
			path: 'edit-workflow-configuration/:workflowId',
			name: `${EMBEDDED_PREFIX}editWorkflowConfiguration`,
			component: EmbeddedEditInstalledWorkflowConfiguration,
			props: (route) => embeddedPropsValidator(route, EmbeddedEditInstalledWorkflowConfiguration),
			meta: { title: 'Configuration', noContentPadding: true },
		},
		{
			path: 'creation-wizard/:featureTypeId',
			name: `${EMBEDDED_PREFIX}CreationWizard`,
			component: EmbeddedCreationWizard,
			props: (route) => ({
				...route.params,
				...['currentUrl', 'elementType'].reduce((acc, param) => (param in route.query ? { ...acc, [param]: route.query[param] } : acc), {}),
				embeddedMode: true,
			}),
		},
	],
};
